import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/home",
    component: Home,
  },
  {
    path: "/home",
    name: "Home",
    meta: { title: "首页" },
    component: Home,
  },
  {
    path: "/studyCollection",
    name: "studyCollection",
    meta: { title: "研究" },
    redirect: "/study/studyCollection",
    component: () => import("../views/PageContainer.vue"),
    children: [
      {
        path: "study",
        name: "study",
        meta: { title: "春阳典藏", keepAlive: true },
        component: () => import("../views/study/studyCollection.vue"),
      },
      {
        path: "studyPublish",
        name: "studyPublish",
        meta: { title: "出版", keepAlive: true },
        component: () => import("../views/study/studyPublish.vue"),
      },
    ],
  },
  {
    path: "/aboutCY",
    name: "aboutCY",
    meta: { title: "关于春阳台" },
    component: () => import("../views/PageContainer.vue"),
    redirect: "/aboutCY/CYTdetail",
    children: [
      {
        path: "CYTdetail",
        name: "CYTdetail",
        meta: { title: "春阳台概况", keepAlive: true },
        component: () => import("../views/aboutCY/CYTdetail.vue"),
      },
      {
        path: "keySpace",
        name: "keySpace",
        meta: { title: "特色空间", keepAlive: true },
        component: () => import("../views/aboutCY/keySpace.vue"),
      },
      {
        path: "architecture",
        name: "architecture",
        meta: { title: "关于建筑", keepAlive: true },
        component: () => import("../views/aboutCY/architecture.vue"),
      },
      {
        path: "CYTMemorabilia",
        name: "CYTMemorabilia",
        meta: { title: "春阳台大事记", keepAlive: true },
        component: () => import("../views/aboutCY/CYTMemorabilia.vue"),
      },
      {
        path: "detail",
        meta: { title: "detail", keepAlive: false },
        component: () => import("../views/Detail.vue"),
      },
    ],
  },
  {
    path: "/exhibition",
    name: "exhibition",
    meta: { title: "展览" },
    component: () => import("../views/PageContainer.vue"),
    redirect: "/exhibition/exhibitionPage",
    children: [
      {
        path: "exhibitionPage",
        name: "ExhibitionPage",
        meta: { title: "展览", keepAlive: true },
        component: () => import("../views/exhibition/exhibitionPage.vue"),
      },
      {
        path: "exhibitionInfo",
        name: "exhibitionInfo",
        meta: { title: "展览详情" },
        component: () => import("../views/exhibition/exhibitionInfo.vue"),
      },
      {
        path: "previousExhibitions",
        name: "previousExhibitions",
        meta: { title: "往期展览", keepAlive: true },
        component: () => import("../views/exhibition/previousExhibitions.vue"),
      },
    ],
  },
  {
    path: "/culturalPage",
    name: "culturalPage",
    meta: { title: "文创" },
    component: () => import("../views/PageContainer.vue"),
    redirect: "/culturalCreative/culturalPage",
    children: [
      {
        path: "culturalCreative",
        name: "culturalCreative",
        component: () => import("../views/culturalCreative/culturalPage.vue"),
      },
    ],
  },
  {
    path: "/ruralvitalization",
    name: "ruralvitalization",
    meta: { title: "塱头古村" },
    component: () => import("../views/PageContainer.vue"),
    redirect: "/rural/ruralvitalization",
    children: [
      {
        path: "Memorabilia",
        name: "Memorabilia",
        meta: { title: "项目大事记", keepAlive: true },
        component: () => import("../views/rural/memorabilia.vue"),
      },
      {
        path: "rural",
        name: "rural",
        meta: { title: "项目概况", keepAlive: true },
        component: () => import("../views/rural/ruralvitalization.vue"),
      },
      {
        path: "projectOverview",
        name: "projectOverview",
        meta: { title: "项目概况", keepAlive: true },
        component: () => import("../views/rural/projectOverview.vue"),
      },
      {
        path: "currentExhibition",
        name: "currentExhibition",
        meta: { title: "当前展览", keepAlive: true },
        component: () => import("../views/rural/currentExhibition.vue"),
      },
      {
        path: "exhibitionOverview",
        name: "exhibitionOverview",
        meta: { title: "展览信息" },
        component: () => import("../views/rural/exhibitionOverview.vue"),
      },
      {
        path: "educationCentre",
        name: "educationCentre",
        meta: { title: "国际驻留" },
        component: () => import("../views/rural/educationCentre.vue"),
      },
      {
        path: "lodgingExperience",
        name: "lodgingExperience",
        meta: { title: "住宿体验", keepAlive: true },
        component: () => import("../views/rural/lodgingExperience.vue"),
      },
    ],
  },
  {
    path: "/visitorGuide",
    name: "visitorGuide",
    meta: { title: "发现更多" },
    component: () => import("../views/PageContainer.vue"),
    redirect: "/visitor/visitor",
    children: [
      {
        path: "visitor",
        name: "visitor",
        meta: { title: "参观指南", keepAlive: true },
        component: () => import("../views/visitor/visitorGuide.vue"),
      },
      {
        path: "Membership",
        name: "Membership",
        meta: { title: "成为会员", keepAlive: true },
        component: () => import("../views/visitor/Membership.vue"),
      },
      {
        path: "pressReleases",
        name: "pressReleases",
        meta: { title: "媒体中心", keepAlive: true },
        component: () => import("../views/visitor/pressReleases.vue"),
      },
      {
        path: "digitalAssets",
        name: "digitalAssets",
        meta: { title: "数字资料", keepAlive: true },
        component: () => import("../views/visitor/digitalAssets.vue"),
      },
        // PDF固定二维码跳转路由（模拟302）
      {
        path: "pdfRedirect",
        name: "pdfRedirect",
        meta: { title: "PDF跳转中" },
        component: () => import("../views/visitor/pdfRedirect.vue"),
      },
      {
        path: "pressReleasesDetail",
        name: "pressReleasesDetail",
        meta: { title: "新闻报道详情", keepAlive: true },
        component: () => import("../views/visitor/pressReleasesDetail.vue"),
      },
    ],
  },
  {
    path: "/activityPage",
    name: "activityPage",
    meta: { title: "活动" },
    component: () => import("../views/PageContainer.vue"),
    redirect: "/activityList/activityPage",
    children: [
      {
        path: "activityList",
        name: "activityList",
        meta: { title: "展览项目", keepAlive: true },
        component: () => import("../views/activityList/activityPage.vue"),
      },
      {
        path: "scienceActive",
        name: "scienceActive",
        meta: { title: "学术活动", keepAlive: true },
        component: () => import("../views/activityList/scienceActive.vue"),
      },
      {
        path: "researchEducation",
        name: "researchEducation",
        meta: { title: "研学与公教活动", keepAlive: true },
        component: () => import("../views/activityList/researchEducation.vue"),
      },
      {
        path: "publicActivities",
        name: "publicActivities",
        meta: { title: "公共活动", keepAlive: true },
        component: () => import("../views/activityList/publicActivities.vue"),
      },
      {
        path: "brandActivity",
        name: "brandActivity",
        meta: { title: "品牌活动", keepAlive: true },
        component: () => import("../views/activityList/brandActivity.vue"),
      },
      {
        path: "activityListInfo",
        name: "activityListInfo",
        meta: { title: "活动详情" },
        component: () => import("../views/activityList/activityListInfo.vue"),
      },
    ],
  },
  {
    path: "/auxiliary",
    name: "Auxiliary",
    meta: { title: "辅助栏目" },
    component: () => import("../views/PageContainer.vue"),
    redirect: "/auxiliary/sitemap",
    children: [
      {
        path: "sitemap",
        name: "Sitemap",
        meta: { title: "网站地图", keepAlive: true },
        component: () => import("../views/auxiliary/Sitemap.vue"),
      },
      {
        path: "law",
        name: "Law",
        meta: { title: "法律声明", keepAlive: true },
        component: () => import("../views/auxiliary/Law.vue"),
      },
      {
        path: "links",
        name: "Links",
        meta: { title: "友情链接", keepAlive: true },
        component: () => import("../views/auxiliary/Links.vue"),
      },
    ],
  },
  {
    path: "/search",
    name: "Search",
    component: () => import("../views/Search.vue"),
  },
  {
    path: "*",
    name: "404",
    component: () => import("../views/404.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  // 添加 scrollBehavior 配置
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return new Promise((resolve) => {
        setTimeout(() => {
          const element = document.querySelector(to.hash);
          if (element) {
            // 对于特定的锚点，使用平滑滚动
            element.scrollIntoView({ behavior: 'smooth' });
            resolve({ el: to.hash, behavior: 'smooth' });
          } else {
            resolve({ x: 0, y: 0 });
          }
        }, 500); // 延迟确保页面加载完成
      });
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

router.beforeEach((to, from, next) => {
  localStorage.setItem("key", to.name);
  document.body.scrollTop = 0;
  // 为了动态修改页面SEO值
  setTimeout(() => {
    // 首先获取到这个 meta 标签
    let meta = document.querySelector('meta[name="description"]');
    let keyword = document.querySelector('meta[name="keywords"]');
    let value = localStorage.getItem("key");
    let lan = localStorage.getItem("lan");

    // 然后修改它的 content 属性
    if (meta) {
      if (value == "CYTdetail") {
        if (lan == 1) {
          meta.setAttribute(
            "content",
            "ChunYangTai is the project’s signature landmark. This newly-built arts and cultural center was donated by the Guangdong Vipshop Philanthropic Foundation and designed by Architect Yung Ho Chang and covers a total area of 8,602 square meters. Located at the entrance of Langtou Village, ChunYangTai serves as an important public plaza in the largest well-preserved national-level historical village of the Pearl River Delta region. ChunYangTai houses a number of multifunctional cultural activity spaces, including five cultural exhibition halls, a library, a rare book room, two reading rooms, a theater, a space for arts and crafts, etc. ChunYangTai becomes an important part of the revitalization of the ancient village and the countryside writ large."
          );
        } else {
          meta.setAttribute(
            "content",
            "春阳台艺文中心是塱头乡村振兴项目新建的标志性建筑。春阳台由建筑师张永和/非常建筑主持设计，位于塱头村村口，总建筑面积8602平米。建筑设计采纳了聚落式布局，将展览、阅读、观演、收藏、研学、餐饮等多元功能分布于十座小型单体建筑之中。这些建筑围合出尺度怡人的街巷和内庭院，并通过曲线优美的“高楼”相互连接。位于各栋建筑屋顶的景观种植池通过空中步道相连，与周边天然荷塘和下沉水院相映成趣，使建筑成为与环境和谐共生的“立体荷塘。"
          );
        }
      } else if (value == "exhibitionPage") {
        if (lan == 1) {
          meta.setAttribute(
            "content",
            "The exhibition conceived jointly by ChunYangTai and the Fondation Giacometti, addresses a new vision of Alberto Giacometti's creation: his relationship with architecture. Giacometti's fascination for monumentality will encounter the Chinese 700-year-old Langtou Village and ChunYangTai contemporary architectural design. Focused on four major aspects of Giacometti's art, this exhibition will enhance his architectural view of the figure from its creation in the apparent fecund chaos of the studio, to his attachment to the base as foundation and the cage as structure, and his manipulation of space and void, in dialogue withZeng Li's photographs, as well as He Jianxiang & Jiang Ying's outdoor installations."
          );
        } else {
          meta.setAttribute(
            "content",
            "在中法建交六十周年之际，由春阳台艺文中心和法国贾科梅蒂基金会共同举办的本次展览，从全新角度解读阿尔贝托·贾科梅蒂的艺术创作，探索他与建筑及空间的关系。贾科梅蒂对“纪念性”的追求将与塱头古村相遇，在这座拥有七百年历史的中国传统文化村落及其标志性新建筑春阳台里，开启一场有关古典与现代、东方与西方的对话。"
          );
        }
      } else if (value == "rural") {
        if (lan == 1) {
          meta.setAttribute(
            "content",
            "Langtou Ancient Village is located in Tanbu Town, Huadu District, Guangzhou City. It was established in the late Southern Song Dynasty and has a history of over seven hundred years. In support of the country’s rural revitalization strategy, in September 2021, the Guangdong Vipshop Philanthropic Foundation and the Huadu District People’s Government of Guangzhou entered a strategic partnership agreement for the Vipshop Rural Revitalization Project in Langtou Village. As a public welfare investment project, Vipshop used cultural revitalization as an entry point for creating a sustainable model of high-quality rural development and the realization of common prosperity in Langtou Village. "
          );
        } else {
          meta.setAttribute(
            "content",
            "塱头古村位于广州市花都区炭步镇，始建于南宋末年，距今已有七百多年历史。为响应国家乡村振兴战略，2021年9月，唯品会公益与广州市花都区政府签订塱头村乡村振兴项目战略合作协议。唯品会公益在塱头村以文化振兴为切入点，通过公益性投入，探索乡村高质量发展、实现共同富裕的可持续模式。"
          );
        }
      } else {
        if (lan == 1) {
          meta.setAttribute(
            "content",
            "ChunYangTai is the project’s signature landmark. This newly-built arts and cultural center was donated by the Guangdong Vipshop Philanthropic Foundation and designed by Architect Yung Ho Chang and covers a total area of 8,602 square meters. Located at the entrance of Langtou Village, ChunYangTai serves as an important public plaza in the largest well-preserved national-level historical village of the Pearl River Delta region. ChunYangTai houses a number of multifunctional cultural activity spaces, including five cultural exhibition halls, a library, a rare book room, two reading rooms, a theater, a space for arts and crafts, etc. ChunYangTai becomes an important part of the revitalization of the ancient village and the countryside writ large."
          );
        } else {
          meta.setAttribute(
            "content",
            "春阳台是塱头乡村振兴项目新建的标志性艺文中心。这座由唯品会公益捐建，建筑师张永和设计的建筑，位于塱头村村口，总建筑面积8602平米，是塱头村乡村活化的重要公共文化活动空间。春阳台内设多种功能的文化活动空间，融合了文博展馆、藏书楼、善本室、阅览室、剧场与艺博活化等多样化空间，成为活化古村、振兴乡村的重要业态。"
          );
        }
      }
    }
    if (keyword) {
      if (value == "CYTdetail") {
        if (lan == 1) {
          keyword.setAttribute(
            "content",
            "ChunYangTai Art and Culture Centre, ChunYangTai Art and Culture Centre, Yung Ho Chang Design, Huadu ChunYangTai, Guangzhou ChunYangTai, Longtou Rural Revitalization's signature landmark, Lingnan Landmark, Greater Bay Area Landmark, ArchDaily 2023 Global Top 100 Best Buildings"
          );
        } else {
          keyword.setAttribute(
            "content",
            "春阳台, 春阳台艺文中心, 春阳台艺术文化中心, 张永和设计, 花都春阳台, 广州春阳台, 塱头乡村振兴项目标志性建筑, 岭南新地标, 岭南文化地标, 大湾区文化地标, ArchDaily全球最佳建筑TOP100"
          );
        }
      } else if (value == "exhibitionPage") {
        if (lan == 1) {
          keyword.setAttribute(
            "content",
            "ChunYangTai exhibition, ChunYangTai permanent exhibition, ChunYangTai temporary exhibition, In Tune with Dao, the Lives and pursuits of Chinese literati, Figure as monument, Alberto Giacometti in Langtou, Fondation Giacometti, China-France Cultural Spring, Sino-French joint curation"
          );
        } else {
          keyword.setAttribute(
            "content",
            "春阳台展览, 春阳台常展, 春阳台常设展览, 春阳台临展, 与道大适, 与道大适, 中国读书人的安身与立命, 1的纪念性, 贾科梅蒂在塱头, 贾科梅蒂基金会, 中法联合策展, 中法文化之春"
          );
        }
      } else if (value == "rural") {
        if (lan == 1) {
          keyword.setAttribute(
            "content",
            "Langtou Ancient Village, Langtou Village, Vipshop Rural Revitalization Project in Langtou Village, Guangdong Vipshop Philanthropic Foundation, ChunYangTai, ChunYangTai Art and Culture Centre, HeChunZhu, HeChunZhu guesthouse, Heart Painting China, The Sun Shines Forever, Jimo Ancient Mansion, Guangzhou Langtou Village, Huadu Langtou Village, Famous Historical and Cultural Villages in China"
          );
        } else {
          keyword.setAttribute(
            "content",
            "塱头古村, 塱头村, 朗头村, 塱头乡村振兴项目, 唯品会公益塱头乡村振兴项目, 唯品会公益, 广东省唯品会慈善基金会, 春阳台, 春阳台艺文中心, 和春住, 和春住民宿, 墨光宝盒, 太阳永照, 积墨楼, 广州塱头村, 花都塱头村, 中国历史文化名村"
          );
        }
      } else {
        if (lan == 1) {
          keyword.setAttribute(
            "content",
            "ChunYangTai Art and Culture Centre, ChunYangTai Art and Culture Centre, Yung Ho Chang, Yung Ho Chang Design, Huadu ChunYangTai, Guangzhou ChunYangTai, Longtou Rural Revitalization, Longtou Model, Lingnan Landmark, Greater Bay Area Landmark, Giacometti in Guangzhou, Giacometti in Longtou, Atelier FCJZ Design, Vipshop rural revitalization project, Chen Xianzhang Chunyangtai"
          );
        } else {
          keyword.setAttribute(
            "content",
            "春阳台艺文中心, 春阳台艺术文化中心, 张永和, 张永和设计, 花都春阳台, 广州春阳台, 塱头乡村振兴, 塱头模式, 岭南新地标, 岭南文化地标, 大湾区文化地标, 贾科梅蒂在广州, 贾科梅蒂在塱头, 非常建筑设计, 陈献章春阳台, 陈白沙春阳台"
          );
        }
      }
    }
    if (value == "CYTdetail") {
      if (lan == 1) {
        document.title =
          "ChunYangTai introduction, ChunYangTai Art and Culture Centre introduction, ChunYangTai Art and Culture Centre, Yung Ho Chang Design, ChunYangTai design concept, ChunYangTai name origin, rooftop lotus ponds";
      } else {
        document.title =
          "春阳台简介, 春阳台艺文中心简介, 春阳台艺术文化中心简介, 张永和设计, 春阳台命名来源, 春阳台设计理念, 屋顶荷塘";
      }
    } else if (value == "exhibitionPage") {
      if (lan == 1) {
        document.title =
          "ChunYangTai exhibition, ChunYangTai permanent exhibition, ChunYangTai temporary exhibition, In Tune with Dao, Figure as monument, Alberto Giacometti in Langtou";
      } else {
        document.title =
          "春阳台展览, 春阳台常展, 春阳台临展, 与道大适, 1的纪念性, 贾科梅蒂在塱头";
      }
    } else if (value == "rural") {
      if (lan == 1) {
        document.title =
          "Langtou Ancient Village, Langtou Village, Vipshop Rural Revitalization Project in Langtou Village";
      } else {
        document.title =
          "塱头古村, 塱头村, 朗头村, 塱头乡村振兴项目, 唯品会公益塱头乡村振兴项目";
      }
    } else {
      if (lan == 1) {
        document.title =
          "ChunYangTai, ChunYangTai official website, Longtou rural revitalization project, Vipshop rural revitalization project";
      } else {
        document.title = "春阳台，塱头乡村振兴公益项目标志性艺文中心，岭南新地标";
      }
    }
  }, 0);
  // firefox
  document.documentElement.scrollTop = 0;
  next();
});

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

export default router;
